import { useEffect, useState } from "react";
import { toast } from "sonner";
import { logEvent } from "@/lib/api";

const BLOCKED = ["c", "x", "p", "s", "u", "a"];

export function useSecurityGuard() {
  const [blurred, setBlurred] = useState(false);

  useEffect(() => {
    const warn = (action, msg) => {
      toast.error(msg);
      logEvent(action, window.location.pathname);
    };
    const isField = (el) => el && ["INPUT", "TEXTAREA"].includes(el.tagName);
    const onKey = (e) => {
      const k = e.key?.toLowerCase();
      if (e.key === "PrintScreen") {
        navigator.clipboard?.writeText("").catch(() => {});
        setBlurred(true);
        setTimeout(() => setBlurred(false), 1500);
        return warn("screenshot_attempt", "Screen capture is not permitted. Attempt logged.");
      }
      if (e.key === "F12" || ((e.ctrlKey || e.metaKey) && e.shiftKey && ["i", "j", "c", "s"].includes(k))) {
        e.preventDefault();
        return warn("devtools_attempt", "This action is disabled. Attempt logged.");
      }
      if ((e.ctrlKey || e.metaKey) && BLOCKED.includes(k)) {
        if (isField(e.target) && ["a", "x", "c"].includes(k)) return;
        e.preventDefault();
        warn(k === "p" ? "print_attempt" : "copy_attempt", "Copying, saving and printing are disabled in TAM. Attempt logged.");
      }
    };
    const onCopy = (e) => {
      if (isField(e.target)) return;
      e.preventDefault();
      warn("copy_attempt", "Copying is disabled in TAM. Attempt logged.");
    };
    const onCtx = (e) => {
      e.preventDefault();
      logEvent("context_menu_blocked", window.location.pathname);
    };
    const onBeforePrint = () => logEvent("print_attempt", window.location.pathname);
    const onBlur = () => setBlurred(true);
    const onFocus = () => setBlurred(false);
    const onDrag = (e) => e.preventDefault();

    window.addEventListener("keydown", onKey, true);
    window.addEventListener("keyup", onKey, true);
    document.addEventListener("copy", onCopy);
    document.addEventListener("cut", onCopy);
    document.addEventListener("contextmenu", onCtx);
    document.addEventListener("dragstart", onDrag);
    window.addEventListener("beforeprint", onBeforePrint);
    window.addEventListener("blur", onBlur);
    window.addEventListener("focus", onFocus);
    return () => {
      window.removeEventListener("keydown", onKey, true);
      window.removeEventListener("keyup", onKey, true);
      document.removeEventListener("copy", onCopy);
      document.removeEventListener("cut", onCopy);
      document.removeEventListener("contextmenu", onCtx);
      document.removeEventListener("dragstart", onDrag);
      window.removeEventListener("beforeprint", onBeforePrint);
      window.removeEventListener("blur", onBlur);
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  return blurred;
}
